import React, { useEffect } from 'react';
import './style.css';

type selectType = {
    value: string,
    label: string
}

interface Props {
    inputs: selectType[],
    title: string,
    name: string,
    selected: string,
    onSubmit: (e: any) => void,
    classValue?: string
}

const SelectComponent: React.FC<Props> = ({inputs, title, name, selected, onSubmit, classValue}) => {
    
    return(
        <div className='w-100'>
            <form action="" className='flex js-sbw' id={name} onSubmit={onSubmit} >
                <div className='radio-title w-100'>{title}</div>
                <div style={{margin: '0px', width: '100%'}}>
                    <select className={classValue ? classValue : 'select-input'}
                            form={name}
                            name={name}
                            defaultValue={selected}
                            onChange={onSubmit}
                    >
                        {
                            inputs.map((input: selectType, i: number ) => {
                                const {value, label} = input;

                                return  (
                                    <option
                                        value={value}
                                        key={value + '' + i}
                                    >
                                        { label }
                                    </option>
                                )
                            })
                        }
                    </select>
                </div>
            </form>
        </div>
    )
}


export default SelectComponent